import React from "react";
import {
  Typography,
  Divider,
  ListItemText,
  Avatar,
  ListItemAvatar,
  List,
  ListItem
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";

const useStyles = makeStyles(theme => ({
  listItem: {
    padding: theme.spacing(0.75, 2, 0.25, 0),
    wordBreak: "break-word"
  },
  divider: {
    marginLeft: theme.spacing(7)
  }
}));

const MessagesList = ({ messages }) => {
  const classes = useStyles();
  const getMessages = () =>
    messages
      ? messages.map((message, index) => (
          <React.Fragment key={index}>
            <ListItem
              alignItems="flex-start"
              classes={{ root: classes.listItem }}
            >
              <ListItemAvatar>
                <Avatar alt={message.name} src={message.img} />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography variant="subtitle1">{message.name}</Typography>
                }
                secondary={
                  <Typography
                    component="div"
                    variant="body2"
                    color="textSecondary"
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: message.content }}
                    />
                  </Typography>
                }
              />
            </ListItem>
            {index !== messages.length - 1 && (
              <Divider
                className={classes.divider}
                variant="inset"
                component="li"
              />
            )}
          </React.Fragment>
        ))
      : [];

  return <List>{getMessages()}</List>;
};

export default MessagesList;

MessagesList.propTypes = {
  messages: PropTypes.array
};
